<template>
    <TableView :heading="__('Division wise Institution')"
        :headers="[
            { name: __('Division'), value: (row) => locale_attr(row, 'division_name_{lang}g') },
            { name: __('Institution'), value: (row) => en_to_bn(row.count) }
        ]"
        :rows="divisions"
        :pagination="pagination"
        :loading="loading"
        @change:page="fetchCounts" />
</template>

<script>
import axios from 'axios';
import TableView from './TableView.vue';

export default {
    components: {
        TableView,
    },

    data() {
        return {
            divisions: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
                from: 0,
                to: 0,
            },
            loading: false,
        }
    },

    mounted() {
        this.observe_visibility(this.$el, () => this.fetchCounts());
    },

    methods: {
        fetchCounts() {
            this.loading = true;
            const params = { page: this.pagination.current_page };
            axios.get('/dashboard/institution-count/division', { params })
                .then(({ data }) => {
                    this.divisions = data.counts.collection;
                    this.pagination = data.counts.pagination;
                })
                .catch(console.error)
                .finally(() => this.loading = false);
        },
    },
}
</script>